import Swiper from "swiper";

const breadcrumbs = document.querySelector(".js-breadcrumbs-slider");

if (window.mobileMedia && breadcrumbs) {
    window.addEventListener("load", () => initBreadcrumbsSwiper(breadcrumbs));
}

function initBreadcrumbsSwiper(swiper) {
    const slides = swiper.querySelectorAll(".swiper-slide");
    const initialSlideIndex = slides.length;

    const nextBtn = swiper.querySelector(".swiper-button-next");
    const prevBtn = swiper.querySelector(".swiper-button-prev");

    const breadcrumbsSwiper = new Swiper(swiper, {
        slidesPerView: "auto",
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        initialSlide: initialSlideIndex,
    });

    if (nextBtn) {
        nextBtn.addEventListener("click", () => {
            breadcrumbsSwiper.slideTo(initialSlideIndex);
        });
    }

    if (prevBtn) {
        prevBtn.addEventListener("click", () => {
            breadcrumbsSwiper.slideTo(0);
        });
    }
}
